// Module
var code = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 18 18\" style=\"enable-background:new 0 0 18 18\" xml:space=\"preserve\"> <circle cx=\"9\" cy=\"9\" r=\"2\"/> </svg> ";
// Exports
module.exports = code;